// DEPRECATED
import glmatrix from '../glmatrix';

export default glmatrix;



//////////////////
// WEBPACK FOOTER
// ./node_modules/claygl/src/dep/glmatrix.js
// module id = 36
// module chunks = 0